import {Icon, IconButton, Tooltip} from "@mui/material";
import {getLabelEstado} from "../../shared/estados";

function IconEstado({estado, semCor}) {
    let color;
    let icon;

    switch (estado) {
        case "AGUARDANDO_APROVACAO":
            color = "info";
            icon = "fact_check";
            break;
        case "EM_FILA":
            color = "default";
            icon = "pending";
            break;
        case "PROCESSAMENTO":
            icon = "cached";
            color = "warning";
            break;
        case "PROCESSADO_COM_SUCESSO":
            color = "success";
            icon = "check_circle_outline";
            break;
        case "PROCESSADO_COM_ERRO":
            color = "error";
            icon = "error_outline";
            break;
        case "RESULTADO_INDETERMINADO":
            color = "warning";
            icon = "report_problem";
            break;
        default:
            color = "default";
            icon = "queue";
    }

    if (semCor) {
        color = undefined;
    }

    return (
        <Tooltip title={getLabelEstado(estado)}>
            <IconButton
                size="small"
                sx={{padding: 0, marginRight: 1}}
                component="span"
                disableRipple
            >
                <Icon color={color}>{icon}</Icon>
            </IconButton>
        </Tooltip>
    );
}

export default IconEstado;
